import { defineStore } from 'pinia'
import pdvApi from '@/app/services/pdv';
import pedidosApi from "@/app/services/pedidos";
import {trunc, hoje} from '@/app/helpers/utils';
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

import createKeyEventHandler from '@/app/helpers/eventhandler';

export const usePDVStore = defineStore('pdv', {

  state: () => ({
    referencia: '',
    produto: {
      produto_id: null,
      referencia: '',
      descricao: '',
      quantidade: 0,
      unidade: null,
      valor: 0,
      subtotal: 0,
      estoque: 0,
      grade: [],
      variacoes: [],
      status: null,
    },

    pedido: {
      data: hoje(),
      produtos: [],
      vendedor_id: null,
      cliente_id: null,
      forma_pagamento: 'Dinheiro',
      taxa_valor: 0,
      desconto_valor: 0,
      valor_bruto: 0,
      valor_liquido: 0,
      quantidade_total: 0,
      itens: 0,
      situacao: 'pdv:venda',
      cliente_nome: '',
    },

    vendas: [],
    pagination: PAGINATION_OPTIONS,
    total_de_registros: 0,
    search: "",
    filtro: {
      data__gte: hoje(),
      data__lte: hoje(),
    },

    pdvProdutosEventsHandler: createKeyEventHandler(),
    pdvFinalizacaoEventsHandler: createKeyEventHandler(),
    
  }),

  getters: {
    itens() {
      return this.pedido.produtos.length;
    },
    subtotal() {
      return this.pedido.produtos.reduce((acc, produto) => acc + produto.valor, 0);
    },
    total() {
      return this.pedido.valor_bruto - this.pedido.desconto_valor + this.pedido.taxa_valor;
    },
  },

  actions: {
    calcularTotais() {
      this.pedido.itens = this.pedido.produtos.length;
      this.pedido.quantidade_total = this.pedido.produtos.reduce((soma, produto) => soma + Number(produto.quantidade), 0);
      this.pedido.valor_bruto = trunc(this.pedido.produtos.reduce((soma, produto) => soma + produto.subtotal, 0));

      this.pedido.valor_liquido = trunc(
        this.pedido.valor_bruto +
        Number(this.pedido.taxa_valor) -
        Number(this.pedido.desconto_valor)
      );
    },

    async finalizarPedido() {
      try {
        const response = await pdvApi.finalizarPedido(this.pedido);
        this.limparPedido();
        this.limparProduto();
        this.referencia = '';
        return response;
      } catch (error) {
        console.error(error);
      }
    },

    limparPedido() {
      this.pedido.produtos = [];
      this.pedido.valor_bruto = 0;
      this.pedido.desconto_valor = 0;
      this.pedido.taxa_valor = 0;
      this.pedido.valor_liquido = 0;
      this.pedido.quantidade_total = 0;
      this.pedido.itens = 0;
      this.pedido.forma_pagamento = 'Dinheiro';
      this.pedido.situacao = 'pdv:venda';
      this.pedido.cliente_nome = '';
    },

    limparProduto() {
      this.produto = {
        produto_id: null,
        referencia: '',
        descricao: '',
        quantidade: 0,
        unidade: null,
        valor: 0,
        subtotal: 0,
        estoque: 0,
        grade: [],
        variacoes: [],
        status: null,
      };
    },

    async listarVendas(data) {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
      this.filtro.data__gte = data;
      this.filtro.data__lte = data;

      const parametros = {
        filtro: {...this.filtro},
        page,
        search: this.search,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };

      parametros.sortBy = parametros.sortBy == "cliente.razao" ? "nome" : parametros.sortBy;

      let pedidos = await pedidosApi.listar(parametros);
      this.pedidos = pedidos.data;
      this.total_de_registros = pedidos.total;
    },

    async impressaoTermica(pedido_id) {
      await pedidosApi.impressaoTermica(pedido_id);
    },
  }
})
